module.exports = __webpack_public_path__ + "img/jidian_keshihua.66e1291e.png";